module.exports = __webpack_public_path__ + "img/MenuButton_TAS.049c00c9.png";